import {Component, Input, OnInit} from '@angular/core';
import {VImage} from "../../models/vet-clinic.model";
import {CommonUtils} from "../../utils/common";
import {ModalController} from "@ionic/angular";
import {FileService} from "../../providers/file.service";
import {AppStateService} from "../../providers/app-state.service";

@Component({
  selector: 'app-full-picture',
  templateUrl: './full-picture.component.html',
  styleUrls: ['./full-picture.component.scss'],
})
export class FullPictureComponent implements OnInit {

  @Input() vClientUUID: string;
  @Input() vImage: VImage;
  @Input() canDelete: boolean = false;

  constructor(private commonUtils: CommonUtils, private modalController: ModalController, private fileservice: FileService, private appStateService: AppStateService) {
  }

  ngOnInit() {
  }

  getPictureUrl() {
    return this.commonUtils.getCloudVImageUrlPath(this.vImage.imageFolder, this.vImage.mFolderUUID, '640', this.vImage);
  }

  onClose() {
    this.modalController.dismiss().then(() => {
    });
  }

  deleteImage() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz usunąć zdjęcie z galerii?',
      'Tak', 'Nie', 'checkmark', 'close', () => {
      this.appStateService.updateIsBusySubject(true)
        this.fileservice.deleteFromCdn(this.vImage.uuid).subscribe(e=>{
          this.appStateService.updateIsBusySubject(false)
          if(e){
            this.commonUtils.presentInfoToast('Zdjęcie usunięte')
            this.onClose();
          } else {
            this.commonUtils.presentAlertToast('Wystąpił błąd podczas usuwania zdjęcia')
          }
        }, error => {
          this.appStateService.updateIsBusySubject(false)
          this.commonUtils.presentAlertToast('Wystąpił błąd podczas usuwania zdjęcia')
        });
      },
      ()=>{});
  }

  onAction() {
    this.modalController.dismiss(this.vImage).then(() => {
    });
  }
}
